import { render } from "./FormularioBaseSocio.vue?vue&type=template&id=4f8d0cf1&scoped=true"
import script from "./FormularioBaseSocio.vue?vue&type=script&lang=js"
export * from "./FormularioBaseSocio.vue?vue&type=script&lang=js"

import "./FormularioBaseSocio.vue?vue&type=style&index=0&id=4f8d0cf1&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8d0cf1"],['__file',"src/views/Legalize/CadastroDeProcessos/Components/FormularioBaseSocio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f8d0cf1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f8d0cf1', __exports__)) {
    console.log('reload')
    api.reload('4f8d0cf1', __exports__)
  }
  
  module.hot.accept("./FormularioBaseSocio.vue?vue&type=template&id=4f8d0cf1&scoped=true", () => {
    console.log('re-render')
    api.rerender('4f8d0cf1', render)
  })

}


export default __exports__